import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom'
import "./login.css"
import Logo from "../assets/images/Logo.png"
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import Img from "../assets/images/user/profile.jpg"
import { axiosInstance } from '../config/https'
import { toast } from "react-toastify";
import { Loader } from "react-overlay-loader"


const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  input: {
    display: "none",
  },
}));

export default function Signup() {
  const classes = useStyles();
  const navigate = useNavigate()
  const [loader, setLoader] = useState(false);

  const [Selectedprofile, setSelectedprofile] = useState("")
  const [profileimage, setprofileimage] = useState(Img)
  const [fname, setFname] = useState("");
  const [lname, setLname] = useState("");
  const [email, setEmail] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");






  const handleInputChange = (event, func) => {
    func(event.target.value)
  }

  const Signup = () => {
    if (fname === '' || lname === '' || password === '' || email === '' || username === '') {
      toast.warning('All feilds required');
    } else if(typeof profileimage == 'string'){
      toast.warning('Please select profile picture');
    }else {
      setLoader(true)
      const formData = new FormData()
      formData.append("fname", fname);
      formData.append("lname", lname);
      formData.append("password", password);
      formData.append("email", email);
      formData.append("username", username);
      formData.append("profile", profileimage);

      axiosInstance.post("user/Register", formData)
        .then((response) => {
          setLoader(false)
          if (response?.data?.status) {
          console.log("if")

            console.log("response", response.data)
            toast.success(response.data.message)
            navigate("/Login")

          }else {
            console.log("else",response.data)
            toast.warn(response?.data?.message)


          }
        }).catch(() => {
          console.log("cattch")

          setLoader(false)


        })
        

    }


  }
  // FOR PROFILE UPLOAD CODE
  const handleInputFileChange = (event, func) => {
    var file = event.target.files[0];
    var reader = new FileReader();
    const filesize = file.size
    const filesizeround = Math.round((filesize / 1024))
    if (filesizeround > 1024) {
      toast.error("plz select your image less then and equals to 1mb")

    }
    else {
      var url = reader.readAsDataURL(file);
      reader.onloadend = function (e) {
        setSelectedprofile(reader.result);
        // setUpdateThumbnail(file);
      };
      func(event.target.files[0])
    }
  }

  return (

    <>
      {loader === true ? <Loader fullPage loading /> : null}

      <section className=' d-flex align-items-center' style={{ height: "120vh" }}>
        <div className='container'>
          <div className='row justify-content-center'>
            <div className='col-lg-6'>
              <div className='login'>

                <div className="head">
                  <img src={Logo} alt='' />

                </div>
                <p className="msg mt-4 para">Signup Your Account</p>
                <div className="form">
                  <form>
                    <div className="row">
                      <div className="col-md-12 rounded-circle">
                        <center>
                          <div className="upload_photo_main photo rounded-circle" >
                            <input
                              onChange={(e) => handleInputFileChange(e, setprofileimage)}

                              accept="image/*"
                              className={classes.input}
                              id="icon-button-file"
                              type="file"

                            />
                            <label htmlFor="icon-button-file">
                              <IconButton
                                color="#414141"
                                aria-label="upload picture"
                                component="span"
                                className="upload_photo_main "
                              >
                                <img src={Selectedprofile ? Selectedprofile : profileimage} style={{ minWidth: "170px", maxWidth: "175px", borderRadius: "20px" }} className="rounded-circle upload_photo_main" alt={""} />
                              </IconButton>

                            </label>


                          </div>

                        </center>
                      </div>
                    </div>

                    <input
                      type="text"
                      placeholder="Enter Your First Name"
                      className="text"
                      value={fname}
                      onChange={(e) => handleInputChange(e, setFname)}

                    />
                    <br />
                    <input
                      type="text"
                      placeholder="Enter Your Last Name"
                      className="text"
                      required=""
                      value={lname}
                      onChange={(e) => handleInputChange(e, setLname)}
                    />
                    <br />
                    <input
                      type="text"
                      placeholder="Enter Your User Name"
                      className="text"
                      value={username}
                      onChange={(e) => handleInputChange(e, setUsername)}
                    />
                    <br />
                    <input
                      className="text"
                      placeholder="Enter Your Email"
                      type="email"
                      value={email}
                      onChange={(e) => handleInputChange(e, setEmail)}
                    />
                    <br />
                    <input
                      type="password"
                      placeholder="Enter Your Password"
                      className="password"
                      value={password}
                      onChange={(e) => handleInputChange(e, setPassword)}
                    />
                    <br />
                    <div className='row'>
                      <div className='col-md-12 mt-2'>
                        <button
                          type="button" className="btn-login rounded-pill" onClick={() => Signup()}>
                          Signup
                        </button>
                        {/* <Link to="#" className="forgot">
                          Forgot?
                        </Link> */}
                      </div>
                    </div>

                  </form>
                  <div className='row'>
                    <div className='col-md-12 text-center mt-4'>
                      <h6>Already have an account?<Link to="/Login"> Login</Link></h6>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </section>

    </>
  )
}
